import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content" }
const _hoisted_3 = { class: "table-header p-d-flex" }
const _hoisted_4 = { class: "p-input-icon-left p-mr-3" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
      start: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('kpi.measureDefinition.title')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_KnFabButton, {
          icon: "fas fa-plus",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showForm(null, false))),
          "data-test": "new-button"
        })
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProgressBar, {
            key: 0,
            mode: "indeterminate",
            class: "kn-progress-bar",
            "data-test": "progress-bar"
          }))
        : _createCommentVNode("", true),
      (_ctx.measuresList.length === 0 && !_ctx.loading)
        ? (_openBlock(), _createBlock(_component_KnHint, {
            key: 1,
            title: 'kpi.measureDefinition.title',
            hint: 'kpi.measureDefinition.hint',
            "data-test": "measure-hint"
          }, null, 8, ["title", "hint"]))
        : (_openBlock(), _createBlock(_component_DataTable, {
            key: 2,
            value: _ctx.measuresList,
            rowGroupMode: "rowspan",
            groupRowsBy: "rule",
            paginator: true,
            rows: 15,
            loading: _ctx.loading,
            class: "p-datatable-sm kn-table",
            dataKey: "id",
            filters: _ctx.filters,
            "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters = $event)),
            globalFilterFields: _ctx.measureDefinitionDescriptor.globalFilterFields,
            responsiveLayout: "stack",
            breakpoint: "960px",
            onRowClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showForm($event.data, false))),
            "data-test": "measures-table"
          }, {
            loading: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
            ]),
            header: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: _ctx.filters['global'].value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                    type: "text",
                    placeholder: _ctx.$t('common.search'),
                    "data-test": "filterInput"
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.measureDefinitionDescriptor.columns, (col) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  class: "kn-truncated",
                  style: col.style,
                  field: col.field,
                  header: _ctx.$t(col.header),
                  key: col.field,
                  sortable: true
                }, null, 8, ["style", "field", "header"]))
              }), 128)),
              _createVNode(_component_Column, {
                style: _ctx.measureDefinitionDescriptor.table.iconColumn.style
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-copy",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.cloneKpiConfirm(slotProps.data)),
                    "data-test": "clone-button"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    icon: "pi pi-trash",
                    class: "p-button-link",
                    onClick: ($event: any) => (_ctx.deleteMeasureConfirm(slotProps.data)),
                    "data-test": 'delete-button-' + slotProps.data.id
                  }, null, 8, ["onClick", "data-test"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value", "loading", "filters", "globalFilterFields"]))
    ])
  ]))
}